module.exports = __webpack_public_path__ + "static/img/ic_bottom_map_off@2x.c4f26c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_map_off@2x.png
// module id = EyV8
// module chunks = 1